import { inject } from 'vue';

export const trackingInjectKey = 'vp-tracking' as const;

/**
 * Every name here is fired by a screen, and every name a screen fires is here — the
 * inventory and its call sites are listed in packages/checkout/doc/claude/analytics.md.
 * Adding a name without a call site re-opens the drift sc-19600 closed: `session_start`
 * and `add_shipping_info` sat in this union mapped and tested on three platforms, and
 * fired by nobody.
 */
export type EventName =
  'view_item' |
  'add_to_cart' |
  'remove_from_cart' |
  'begin_checkout' |
  'purchase' |
  'add_payment_info' |
  'access_code_applied';

export type UseTrackingComposable = {
  track: (...args: any[]) => void;
  trackEvent(name: EventName, payload?: unknown): void;
};

const useTracking = (): UseTrackingComposable => {
  const tracking = inject<UseTrackingComposable>(trackingInjectKey);

  if (!tracking) {
    throw new Error('useTracking can only be used as a child of TrackingProvider.');
  }

  return tracking;
};

export {
  useTracking,
};
